module.exports = __webpack_public_path__ + "media/application/images/icons/green-arrow-left-b640fcefde604b741bd1ca8625d6fc7b.svg";